import userApi from '../../api/user'
import * as types from '../mutation-types'

// initial state
const state = {
  payMoneyList: [],
  pageSize: 10,
  pageIndex: 1,
  maxPageSize: 1
}

// actions
const actions = {
  getPayMoney ({ commit }, payload) {
    commit(types.SET_ACCOUNT_PAYMONEY_PAGEINDEX, { pageIndex: 1 })
    let promise = userApi.getPayMoneyListData(
      {
        pageSize: state.pageSize,
        pageNo: state.pageIndex,
        PlatformAgentID: payload.PlatformAgentID,
        dataType: payload.dataType
      }).then(res => {
        if (!res) {
          return
        }
        console.log('可提现金额列表信息', res.data.result.paySettlements)
        commit(types.SET_ACCOUNT_PAYMONEY_MAXPAGESIZE, { pageCount: res.data.result.pageCount })
        var list = res.data.result.paySettlements
        commit(types.RECEIVE_PAYMONEY_LIST, { list })
      })
    return promise
  },
  // 加载更多
  loadMorePayMoney ({ commit }, payload) {
    const pageNo = state.pageIndex + 1
    commit(types.SET_ACCOUNT_PAYMONEY_PAGEINDEX, { pageIndex: pageNo })
    let promise = userApi.getPayMoneyListData(
      {
        pageSize: state.pageSize,
        pageNo: state.pageIndex,
        PlatformAgentID: payload.PlatformAgentID,
        dataType: payload.dataType
      }).then(res => {
        if (!res) {
          return
        }
        console.log('追加可提现金额列表信息', res.data.result.paySettlements)
        var list = res.data.result.paySettlements
        commit(types.APPEND_PAYMONEY_LIST, { list })
      })
    return promise
  }
}

// mutations
const mutations = {
  // 设置订单列表
  [types.RECEIVE_PAYMONEY_LIST] (state, { list }) {
    state.payMoneyList = list
  },
  // 追加订单列表
  [types.APPEND_PAYMONEY_LIST] (state, { list }) {
    if (list && list.length > 0) {
      for (var i = 0; i < list.length; i++) {
        state.payMoneyList.push(list[i])
      }
    }
  },
  // 设置最大页数
  [types.SET_ACCOUNT_PAYMONEY_MAXPAGESIZE] (state, { pageCount }) {
    state.maxPageSize = pageCount
  },
  // 设置当前页数
  [types.SET_ACCOUNT_PAYMONEY_PAGEINDEX] (state, { pageIndex }) {
    state.pageIndex = pageIndex
  }
}

// getters
const getters = {
  payMoneyList: state => state.payMoneyList,
  isPayMoneyPageEnd: state => state.pageIndex >= state.maxPageSize
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/paymoney.js